import { render, staticRenderFns } from "./ListaReservado.vue?vue&type=template&id=3c1abd5b&scoped=true"
import script from "./ListaReservado.vue?vue&type=script&lang=js"
export * from "./ListaReservado.vue?vue&type=script&lang=js"
import style0 from "./ListaReservado.vue?vue&type=style&index=0&id=3c1abd5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1abd5b",
  null
  
)

export default component.exports